@if (variant === "chevron") {
@if(link?.type === "internal") {
<a class="smart-link-chevron" [ngClass]="{ 'placeholder': !link }" [routerLink]="link?.url">
    <ng-container *ngTemplateOutlet="chevron"></ng-container>
</a>
} @else if(link?.type === "external") {
<a class="smart-link-chevron" [ngClass]="{ 'placeholder': !link }" target="_blank" href="{{link?.url}}">
    <ng-container *ngTemplateOutlet="chevron"></ng-container>
</a>
} @else if(link?.type === "parent") {
<a class="smart-link-chevron" [ngClass]="{ 'placeholder': !link }" href="#" (click)="$event.preventDefault(); navigate(link?.url)">
    <ng-container *ngTemplateOutlet="chevron"></ng-container>
</a>
}
} @else {
@if(link?.type === "internal") {
<a appStandardButton [ngClass]="{ 'placeholder': !link }" [routerLink]="link?.url" class="w-100">
    {{ link?.text ?? "-" }}
</a>
} @else if(link?.type === "external") {
<a appStandardButton [ngClass]="{ 'placeholder': !link }" target="_blank" href="{{link?.url}}" class="w-100">
    {{ link?.text ?? "-" }}
</a>
} @else if(link?.type === "parent") {
<a appStandardButton [ngClass]="{ 'placeholder': !link }" (click)="navigate(link?.url)" class="w-100">
    {{ link?.text ?? "-" }}
</a>
}
}

<!-- Round icon-only link; the link text stays as its accessible name -->
<ng-template #chevron>
    <ng-icon name="phosphorCaretRight" aria-hidden="true"></ng-icon>
    <span class="visually-hidden">{{ link?.text ?? "-" }}</span>
</ng-template>
